import { Box, Card, CardBody, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { ACCENT_1_COLOR, PRIMARY_COLOR } from '../constants/color';

// Reusable Feature Card Component
const CustomCard = ({ image, title, titleDesc, description, badge, isVideo = false }) => {
  return (
    <Card w="250px" overflow="hidden" borderRadius="0" border={"0px"} boxShadow={"none"} bg="transparent">
      {isVideo ? <Box
        as="video"
        src={image} // Your webm video path
        width="250px"
        height="190px"
        objectFit="cover" // Keeps the video aspect ratio clean within the bounds
        autoPlay
        loop
        muted
        playsInline
      /> : <Image
        src={image}
        alt={title}
        width={"250px"}
        height={"190px"}
        objectFit="cover" // Keeps aspect ratio and fills the box
        overflow="hidden"
      />}

      <CardBody paddingTop={"12px"}>
        <Text fontSize={"22px"} className='cormorant-garamond-bold' color={ACCENT_1_COLOR}>{title}</Text>
        <Text fontSize={"20px"} className='cormorant-garamond-bold' color={ACCENT_1_COLOR}>{titleDesc}</Text>
        <Text py="8px" className='cormorant-garamond-normal' color={PRIMARY_COLOR} align={"justify"}>
          {description}
        </Text>
      </CardBody>
    </Card>
  );
};

export default CustomCard;